/**
 * @file index.tsx
 *
 * @fileoverview Renders the initial metatags for pages, if a page / query then has metadata these would be
 * overriden. This component should be called fairly high in the tree so that it never overrides anything, but rather other components override it.
 */
import Head from 'next/head';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

// OG image meta name. Used to set default OG image key.
// The value must equal the corresponding API MetaTag meta property value.
export const OG_IMAGE_META_NAME = 'og:image';

interface MetatagDefaultProps {
  /**
   * The current host.
   */
  host: string;
}

export default function MetatagDefault({ host }: MetatagDefaultProps) {
  const { APP } = useFrontendConfig();

  return (
    <Head>
      <title key="title">{APP.SITENAME}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta
        key="description"
        name="description"
        content={APP.SITE_DESCRIPTION}
      />
      {APP.OG_IMAGE && (
        <meta
          key={OG_IMAGE_META_NAME}
          name={OG_IMAGE_META_NAME}
          property={OG_IMAGE_META_NAME}
          content={`${host}${APP.OG_IMAGE}`}
        />
      )}
    </Head>
  );
}
